import React, { Component } from "react";
import { Helmet } from "react-helmet";

import HowItWorks from "./affiliate/HowItWorks";
import Marketing from "./affiliate/Marketing";
import ScrollableTabs from "./affiliate/Tabs";

import Sports from "../images/icon-sports.svg";
import Casino from "../images/icon-casino.svg";
import LiveCasino from "../images/icon-live-casino.svg";


class Affiliate extends Component {
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("root").classList.add("affiliate");
    document.getElementById("foo").classList.add("overflow");
  }

  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Affiliate Partners</title>
          <meta
            name="description"
            content="STech offers a tiered revenue share structure to their affiliate partners…"
          />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">


            <h1> STech - Affiliate</h1>

            <div className="title-affiliate-h2">
          <h2>Why work with us?</h2>
</div>

          <div className="title-affiliate">
        Click <a href="https://partners.stechaffiliates.com/login.asp"> here</a> to join now, or email us at <a href="mailto:affiliate@stech.com " target="_top"> affiliate@stech.com </a> for more information.
</div>


            </div>
          </div>
        </header>
        <section className="clearfix fadeInUp why margin">
          <div className="container">
          <div className="content fristpara">
          Stech provides a revenue share scheme which involves a tiered approach in addition to many proactive parametres to create a tailored structure to all its affiliates individually.
</div>
            <div className="content">
              Stech Affiliates is the dedicated affiliate management programme of Stech Technology UK Limited, covering its operator platforms. Since its creation in 2016, Stech have been a solid provider for casino and sportsbook platforms which sustain a plug&run ease to all operators.
            </div>
            <div className="row">
              <div className="col">
                <img src={Sports} title="Sports" alt="Sports" />
                <h2>Sports</h2>
              </div>
              <div className="col">
                <img src={Casino} title="Casino" alt="Casino" />
                <h2>Casino</h2>
              </div>
              <div className="col">
                <img
                  src={LiveCasino}
                  title="Live Casino"
                  alt="Live Casino"
                />
                <h2>Live Casino</h2>
              </div>
            </div>

            <div className="content">
              Stech might be considered as relatively young company. Yet the minds behind the show are all veterans of the industry, coming from all angles… operations for both provider and operator side, IT development, finance and marketing. That blend is what makes us capable of understanding the needs and perspectives of our clients, no matter what the background and intended goal is.
            </div>
          </div>
        </section>
        <section className="clearfix fadeInUp">
          <div className="snap">
            <div id="animate2" />
            <div id="animate1" />
          </div>
        </section>
        <HowItWorks />
        <Marketing />
        <ScrollableTabs />
        <section className="clearfix fadeInUp ready" id="how">
          <div className="container">
            <div className="title-1">Do you want to start earning now?</div>
            <div className="content">
              <p>Join the team today – there's never been a better time.</p>
              <a
                href="https://partners.stechaffiliates.com/login.asp"
                target="_blank"
                title="Start Earning Today"
                rel="noopener noreferrer"
              >
                Start Earning Today
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Affiliate
